export const SCHEMA_NAME = "CivilPapersPropertySales";

export const FIELDS = {
  CIVIL_PAPERS_PROPERTY_SALE_ID: "civilPapersPropertySaleID",
  CIVIL_PAPER_ID: "civilPaperID",
  DEBT_AMOUNT: "debtAmount",
  SALE_DATE: "saleDate",
  DISTRIBUTION_DATE: "distributionDate",
  PROPERTY_ADDRESS_ID: "propertyAddressID",
  DEED_FILING_DATE: "deedFilingDate",
  TAX_CODE: "taxCode",
  PIN: "pin",
  TAX_COLLECTOR: "taxCollector",
  SCHOOL_CODE: "schoolCode",
  MONIES_LEVIED: "moniesLevied",
  DATE_OF_LEVY: "dateOfLevy",
  DISTRICT_JUSTICE: "districtJustice",
};
